import { FC, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 } from "uuid";

import { ITemplateRow } from "@framework/types";
import { ProgressOverlay } from "@framework/mui-page-layout";
import { useAsu } from "@framework/provider-asu";
import { useApiCall } from "@framework/react-hooks";

import { DiagramSelector } from "./selector";

export const Diagrams: FC = () => {
  const { selectedItem, startTimestamp, endTimestamp } = useAsu();

  const [templates, setTemplates] = useState<ITemplateRow[] | null>(null);

  const selectedItemId = selectedItem && ("Id" in selectedItem ? selectedItem.Id : selectedItem.TrainId);
  const selectedItemType = selectedItem && ("Id" in selectedItem ? 1 : 2);

  const { fn: getTemplateApi, isLoading } = useApiCall(
    (api, data) => {
      return api
        .fetchJson({
          url: "/template/1",
          data,
        })
        .then(json => {
          setTemplates(json);
        })
        .catch(console.error);
    },
    { error: false, success: false },
  );

  useEffect(() => {
    if (selectedItemId && selectedItemType) {
      void getTemplateApi(void 0, {
        params: {
          type: selectedItemType,
          startDate: startTimestamp,
          endDate: endTimestamp,
          idObject: selectedItemId,
          // idChildObject: [],
        },
      });
    }
  }, [selectedItemId, selectedItemType, endTimestamp]);

  return (
    <ProgressOverlay isLoading={isLoading} wrapperSx={{ overflow: "auto" }}>
      <Box sx={{ height: "auto", mb: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mt: 5,
          }}
        >
          {templates?.map(template => {
            const { block, data } = template;
            const header = block.header;

            if (!data?.length) {
              return null;
            }

            return (
              <Box key={v4()} sx={{ mt: 2, mb: 2, textAlign: "center" }}>
                {header ? (
                  <Typography variant="h3" sx={{ mb: 1 }}>
                    {`${header.charAt(0).toUpperCase()}${header.slice(1)}`}
                  </Typography>
                ) : null}
                <DiagramSelector data={data} size={block.__Size} type={block.__type} />
              </Box>
            );
          })}
        </Box>
      </Box>
    </ProgressOverlay>
  );
};
